<script>
    import { Meteor } from "meteor/meteor";

    let {
        heading = "Get in touch",
        intro = "Tell us about the vehicle or financing help you need.",
        submitLabel = "Send Message",
        className = "",
    } = $props();

    let form = $state({
        fullName: "",
        phoneNumber: "",
        emailAddress: "",
        interestedVehicle: "",
        message: "",
    });
    let formState = $state({ submitting: false, success: "", error: "" });

    function submitContact(event) {
        event.preventDefault();
        formState = { submitting: true, success: "", error: "" };

        Meteor.call(
            "contacts.submit",
            {
                payload: { ...form },
            },
            (error) => {
                if (error) {
                    formState = {
                        submitting: false,
                        success: "",
                        error:
                            error.reason || "Failed to submit contact request.",
                    };
                    return;
                }

                formState = {
                    submitting: false,
                    success: "Thank you. We will contact you shortly.",
                    error: "",
                };
                form = {
                    fullName: "",
                    phoneNumber: "",
                    emailAddress: "",
                    interestedVehicle: "",
                    message: "",
                };
            },
        );
    }
</script>

<div class={["contact-form-shell", className]}>
    <h2>{heading}</h2>
    {#if intro}
        <p class="contact-form-intro">{intro}</p>
    {/if}
    <form onsubmit={submitContact}>
        <div class="form-grid">
            <label>Full Name<input required bind:value={form.fullName} /></label
            >
            <label
                >Email<input
                    required
                    type="email"
                    bind:value={form.emailAddress}
                /></label
            >
            <label>Phone<input bind:value={form.phoneNumber} /></label>
            <label
                >Vehicle Interest<input
                    bind:value={form.interestedVehicle}
                /></label
            >
            <label class="full"
                >Message<textarea required rows="4" bind:value={form.message}
                ></textarea></label
            >
        </div>
        <button type="submit" disabled={formState.submitting}
            >{formState.submitting ? "Sending..." : submitLabel}</button
        >
        {#if formState.error}<p class="error">{formState.error}</p>{/if}
        {#if formState.success}<p class="success">{formState.success}</p>{/if}
    </form>
</div>
